module.exports = __webpack_public_path__ + "static/img/blood-pressure.f06a0af.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/blood-pressure.png
// module id = N8RR
// module chunks = 1